import PolicyInfo from './PolicyInfo';
import PolicyScopes from './scopes/policyScopes';

const ScopeTab = () => {
    return (
        <div className="flex flex-col gap-4">
            <PolicyInfo />
            <PolicyScopes />
        </div>
    );
};

export default ScopeTab;
